import TruckIcon from "@redotech/redo-icons/truck-02.svg";
import { RedoShopifyDeliveryMethodType } from "@redotech/redo-model/fulfillments/fulfillment-delivery-method-type";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { deliveryMethodText } from "../../common/delivery-method-badge";

const entry = fgFilterEntries.deliveryMethod;

export const DeliveryMethodFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  Icon: TruckIcon,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "delivery method",
  itemLabelPlural: "delivery methods",
  values: [...entry.staticValues],
  display: (item: string) => {
    return deliveryMethodText[item as RedoShopifyDeliveryMethodType];
  },
  displayName: entry.displayName,
};
